import { useHistory } from 'react-router-dom'

import NewNoteForm from '../notes/NewNoteForm';

function NewNotesPage() {

    const history = useHistory();

    function addNoteHandler(noteData) {
        fetch(
            'https://react-explore-f6049-default-rtdb.firebaseio.com/notes.json',
            {
                method: 'POST',
                body: JSON.stringify(noteData),
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        ).then(() => {
            history.replace('/');
        });
    }

    return (
        <section>
            <h1>New Note</h1>
            <NewNoteForm onAddNote={addNoteHandler}/>
        </section>
    );
}

export default NewNotesPage;